import { Injectable } from "@angular/core";
import * as CubiqTS from "shared/cubiq-model-multi-asset";
import {
  PRIMITIVE,
  ServiceMessageBroker,
  ServiceMessageBrokerFactory,
} from "shared/provider-webworker";

import { OrderDataPromiseLookupService } from "../../../../lookup/model/impl/OrderDataPromiseLookupService";
import { BfxBlotterAction } from "../../../../model/contextmenu/bfx-base-blotter/BfxBlotterAction";
import { BfxBlotterOrdersContextMenuAcceptanceItem } from "../../../../model/contextmenu/bfx-blotter-orders/BfxBlotterOrdersContextMenuAcceptanceItem";
import { BfxBlotterOrdersContextMenuItem } from "../../../../model/contextmenu/bfx-blotter-orders/BfxBlotterOrdersContextMenuItem";
import { BfxBlotterOrdersContextMenuState } from "../../../../model/contextmenu/bfx-blotter-orders/BfxBlotterOrdersContextMenuState";
import { ContextMenuItem } from "../../../../model/contextmenu/ContextMenuItem";
import { ContextMenuItemState } from "../../../../model/contextmenu/ContextMenuItemState";
import { ContextMenuItemStateCommandCriteria } from "../../../../model/contextmenu/ContextMenuItemStateCommandCriteria";
import { ContextMenuState } from "../../../../model/contextmenu/ContextMenuState";
import { IContextMenuService } from "../../IContextMenuService";
import {
  FIND_ORDERS_CONTEXT_MENU_SERVICE,
  IFindOrdersContextMenuService,
} from "../IFindOrdersContextMenuService";
import { BfxBlotterOrdersContextMenuPromiseService } from "../../bfx-blotter-orders/impl/BfxBlotterOrdersContextMenuPromiseService";
import { ContextMenuService } from "../../impl/ContextMenuService";
import { ContextMenuServiceResponse } from "../../../../model/contextmenu/ContextMenuServiceResponse";

export abstract class BfxFindOrdersContextMenuPromiseService extends BfxBlotterOrdersContextMenuPromiseService {
  public abstract getMenuItems(
    selectedIds: Array<string>,
    menuState: ContextMenuState,
  ): Promise<ContextMenuServiceResponse<CubiqTS.OrderDataImpl, BfxBlotterOrdersContextMenuItem>>;
}
